const tenantId = process.env.REACT_APP_MSAL_TENANT_ID || 'YOUR_TENANT_ID';

export const msalConfig = {
    authority: `https://login.microsoftonline.com/${tenantId}`,
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID || 'YOUR_CLIENT_ID',
    redirectUri: document.getElementById('root').baseURI
};